/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-08 18:16:27
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-06-21 17:24:01
 * @FilePath: /unifyxp-v2-store-portal/src/components/LinkModule/Components/TextItem/index.tsx
 */
import React from 'react';

import { Tooltip } from 'antd';

import styles from './style.module.less';

type Props = {
  id?: string;
  title: string;
  desc?: string | JSX.Element;
  onClick?: () => void;
  selected?: boolean;
};

function TextItem({ id, title, desc, onClick, selected }: Props) {
  return (
    <div
      style={{
        backgroundColor: selected ? '#E5F7E9' : undefined,
      }}
      className={styles.container}
      onClick={onClick}>
      <Tooltip title={title}>
        <div className={styles.title}>{title}</div>
      </Tooltip>
      {desc && (
        <Tooltip title={desc}>
          <div className={styles.desc}>{desc}</div>
        </Tooltip>
      )}
    </div>
  );
}

export default TextItem;
